import $ from 'jquery';
/**
 * Snackbar - Class representing popup toastr/snackbar message
 */
class Snackbar {
  /**
   * Show snackbar message
   * @param {String} message - Message that will be displayed in snackbar
   * @param {Number} delay [delay=6000] - Time before snackbar disappear in milliseconds (ms)
   */
  show(message, delay = 6000) {
    this.snackbar = $('.snackbar').first();
    if (this.snackbar) {
      this.snackbarText = this.snackbar.find('.snackbar__text');
      this.snackbar.on('click', () => {
        this.snackbar.removeClass('active');
      });
    }

    this.snackbarText.text(message);
    setTimeout(() => {
      this.snackbar.addClass('active');
    }, 0);
    setTimeout(() => {
      this.snackbar.removeClass('active');
      this.snackbarText.text('');
    }, parseInt(delay, 10));
  }
}

const snackbar = new Snackbar();
export default snackbar;
